module.exports = __webpack_public_path__ + "assets/img/group-name.c5da381e.png";